import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';
import AddressValue from './AddressValue';

const PoiLocationValue = ({
  latitude,
  longitude,
  poiId,
  poiName,
  originalAddress,
}) => {
  if (poiName) {
    const tooltipTitle = originalAddress || `${latitude?.toFixed(6)}, ${longitude?.toFixed(6)}`;
    return (
      <Tooltip title={tooltipTitle} arrow>
        <Chip
          icon={<PlaceIcon />}
          label={poiName}
          size="small"
          color="primary"
          variant="outlined"
          sx={{ cursor: 'default' }}
        />
      </Tooltip>
    );
  }

  return (
    <AddressValue
      latitude={latitude}
      longitude={longitude}
      originalAddress={originalAddress}
    />
  );
};

export default PoiLocationValue;
